import Page from 'components/Page';
import React from 'react';

export default function CreateMembership() {
  return (
    <Page title="Thêm thành viên">
      <></>
    </Page>
  );
}
